<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../common/config/app-config';
  import { isMobileUIExperience } from '../../common/util';
  import Icon from '../common/components/Icon.svelte';
  import { FOOTER_CONTENT_SLOTS, FOOTER_MIDDLE_CONTENT_SLOTS } from '../common/lazy-components/driver/common-mapper';
  import { CMSExternalLinksComponent } from '../common/lazy-components/driver/LazyComponents.svelte';
  import { getPageDataFromHybrisAsync } from '../common/services/hybris';
  import { getFooterData } from '../home/services/home-data-services';
  import BottomSection from './component/BottomSection.svelte';
  import MiddleSection from './component/MiddleSection.svelte';
  import TestFreakFooterComponent from './component/TestFreakFooterComponent.svelte';

  let footerComponents = [];
  let middleSectionData;
  let footerTopFullData;
  let footerBottomFullData;
  const { pageId } = getAppConfig();
  let cmsLinkComp;
  /**
   * Called when the component is mounted.
   * Fetches the footer data and page data from Hybris and sets the footerComponents array.
   * The footerComponents array is sorted by position to ensure Top -> Middle -> Bottom order.
   */
  /**
   * Called when the component is mounted.
   * Fetches the footer data and page data from Hybris and sets the footerComponents array.
   * The footerComponents array is sorted by position to ensure Top -> Middle -> Bottom order.
   * @returns {Promise<void>}
   */
  async function loadFooterData() {
    try {
      // Fetch the footer data
      await getFooterData();

      // Fetch the page data
      const pageData = await getPageDataFromHybrisAsync(pageId);

      // Extract the content slots from the page data
      const contentSlots = pageData?.contentSlots?.contentSlot;

      // Filter the content slots to only include the footer content slots
      footerComponents = contentSlots?.filter(slot => FOOTER_CONTENT_SLOTS.includes(slot?.position));

      // Filter the content slots to only include the middle section content slots
      middleSectionData = contentSlots?.filter(slot => FOOTER_MIDDLE_CONTENT_SLOTS.includes(slot?.position));

      // Find the footer top full content slot
      footerTopFullData = contentSlots?.find(slot => slot?.position === 'FooterTopFull');

      footerBottomFullData = contentSlots?.filter(
        slot => slot?.position === 'Footer' || slot?.position === 'FooterMciCertificate'
      );
      console.log(footerBottomFullData, 'footerBottomFullData');

      // Sort the footer components by position
      footerComponents.sort((a, b) => {
        const positionOrder = FOOTER_CONTENT_SLOTS;
        return positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
      });
      middleSectionData.sort((a, b) => {
        const positionOrder = FOOTER_MIDDLE_CONTENT_SLOTS;
        return positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
      });

      console.log(footerComponents, 'footerComponents');
      console.log(middleSectionData, 'middleSectionData');
      // Call the onLoad method of the CMS links component
      queueMicrotask(() => {
        cmsLinkComp?.onLoad();
      });
    } catch (error) {
      console.error('Error loading footer data:', error);
    }
  }

  // onMount(loadFooterData);

  onMount(() => {
    loadFooterData();
    if (!isMobileUIExperience()) {
      window['ACC'].backToTop.onLoad();
    }
  });

  /**
   * Function to get component and component data based on footer slot data
   * @param {Object} footerSlotData - The footer slot data
   * @returns {Object} - Object with component and component data
   */
  function getComponentData(footerSlotData) {
    const footerComponentData = {
      component: null,
      metaData: null,
    };
    // Middle section component
    if (footerSlotData.position === 'FooterMiddleB') {
      footerComponentData.component = MiddleSection;
      footerComponentData.metaData = middleSectionData;
    }
    // Bottom section component
    else if (footerSlotData.position === 'Footer') {
      footerComponentData.component = BottomSection;
      footerComponentData.metaData = footerBottomFullData;
    }
    return footerComponentData;
  }
</script>

<footer class="container-fluid footer">
  {#if footerComponents?.length}
    {#if footerTopFullData}
      {#each footerTopFullData.components.component as topComponent}
        {#if topComponent?.uid === 'SellerReviewComponent'}
          <TestFreakFooterComponent />
        {/if}
        {#if topComponent?.typeCode === 'CMSExternalLinksComponent'}
          <CMSExternalLinksComponent bind:this={cmsLinkComp} metaData={topComponent} />
        {/if}
      {/each}
    {/if}

    <div class="middle-section">
      {#each footerComponents as content}
        {@const { component, metaData } = getComponentData(content)}
        <svelte:component this={component} {metaData} />
      {/each}
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="c_back-to-top js-goTo-top" on:click={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
      <a class="link" href="javascript:void(0);" aria-label="Back to top">
        <Icon glyph="chevron_up" />
      </a>
    </div>
  {/if}
</footer>

<style lang="scss">
  @import '../../common/styles/vars';
  .footer {
    height: auto;
    background-color: $color-bright-gray;
    padding: 0;
    text-align: start;
    overflow: hidden;
    .middle-section {
      flex-direction: column;
    }
    .c_wrapper--content_new {
      background: $neutral-dark-01;
    }
  }

  .footer-last {
    background: white;
    text-align: center;

    p {
      padding: 1rem 0;
      margin: 0;
    }
  }

  .c_back-to-top {
    :global(.c_icon_new--chevron_up) {
      font-weight: 700;
      filter: drop-shadow(0 0 1px currentColor);
      text-shadow:
        0 0 1px currentColor,
        0 0 1px currentColor;
    }
  }
</style>
